import useStudentContext from '@/data/hook/useStudentContext';
import useFilterParams from '@/utils/UseFilterParams';
import { filterToServiceFilterAdapter } from '@/utils/courseProgress';
import { searchParamsToObject } from '@/utils/searchParamsToObject';
import {
  CourseProgressFilter,
  CourseProgressFilters,
} from './CourseProgressFilter';
import CourseProgressList from './CourseProgressList';
import { CourseFormatEnum } from '@/models/Course';

export default function CourseProgressView() {
  const { courseProgressFilters } = useStudentContext();

  const { filterParams, setFilterParams } =
    useFilterParams<CourseProgressFilter>();

  const filtersFromParams = searchParamsToObject<CourseProgressFilter>(
    filterParams,
    {
      courseFormats: {
        type: 'string',
      },
      search: {
        type: 'string',
      },
      ordering: {
        type: 'string',
      },
    },
  );

  const dinamicFilters = filterToServiceFilterAdapter(filtersFromParams);

  const fixedFilters = courseProgressFilters;

  const filters = {
    ...dinamicFilters,
    ...fixedFilters,
    exCourseFormats: [CourseFormatEnum.EXTRA_COURSE],
  };

  return (
    <div className="flex flex-col gap-2.5">
      <CourseProgressFilters
        filter={filtersFromParams}
        onChange={setFilterParams}
      />
      <CourseProgressList filters={filters} />
    </div>
  );
}
